<template>
  <div class="container">
    <a-popover
      style="left: 500px"
      :placement="placement"
      :getPopupContainer="getPopupContainer"
      :trigger="trigger"
      v-model:visible="popoverVisible"
      overlayClassName="solePopover-container"
      :mouseEnterDelay="mouseEnterDelay"
    >
      <template #title>
        <div>
          <div class="popover-header z-flex">
            <div class="popover-header-img">
              <auth-img :src="data.headUrl || item.cb" />
            </div>
            <div class="popover-header-info z-flex">
              <div class="name z-flex">
                <div>{{ data.username }}</div>
                <auth-img :src="handleImg(data.gender)" v-if="[0, 1].includes(data.gender)" />
              </div>
              <div class="base_info number">
                {{ item.p_title.label }}{{ data[`${item.p_title.key}`] }}
              </div>
              <div class="base_info">
                使用权限：
                <span :class="{ permission: [1, 2, 3].includes(data.accountStatus) }">
                  {{ ['正常', '停用', '注销', '停用 | 注销'][data.accountStatus] || '--' }}
                </span>
              </div>
            </div>
            <div class="popover-header-ext">
              <div v-if="activeKey === 'doctor'" class="satisfaction" @click="satisfactionClick">
                口碑赞誉
              </div>
            </div>
          </div>
          <!-- 医生标签 -->
          <div class="certificationInfoStyle" v-if="certificationInfo">
            认证备案：
            <span v-for="(item, index) in certificationInfo" :key="index" style="color: #1890ff">
              {{ item.label }}
              <span v-if="index < certificationInfo.length - 1" style="margin-right: 3px">·</span>
            </span>
          </div>
          <div v-if="data.doctorPatientProjectLabelInfoList" class="ServiceTags">
            <!-- doctorPatientProjectLabelInfoList- {{ data.doctorPatientProjectLabelInfoList }} -->
            <span
              v-for="tag in data.doctorPatientProjectLabelInfoList"
              :key="tag.projectCode"
              class="ServiceTag"
            >
              {{ tag.projectName }}
            </span>
          </div>
          <template v-if="activeKey === 'doctor'" @click.stop>
            <RemarkPopover
              v-bind="$attrs"
              mode="doctor"
              @updateRemark="() => emit('updateRemark')"
              :allowClear="true"
            />
          </template>
        </div>
      </template>
      <template #content>
        <div class="popover-content">
          <div class="box_container">
            <div
              class="box z-flex"
              v-for="(it, index) in item.p_content"
              :key="it.label"
              :class="{
                first_box: index === 0,
                last_box: it.key === 'changeAt' && data['changeAt']
              }"
            >
              <div class="title">{{ it.label }}</div>
              <div class="details" :class="{ announcement_update: it.key === 'changeAt' }">
                <span
                  v-if="activeKey === 'doctor' && it.key === 'doctorTitleId'"
                  class="departName"
                >
                  {{ handleLabel(data, 'doctorDepartmentName') }}
                </span>
                {{ handleLabel(data, it.key) }}
              </div>
            </div>
          </div>

          <!-- 医生价格展示 -->
          <div class="doctor_price_info" v-if="activeKey === 'doctor'">
            <div
              class="info_item"
              v-for="infoItem in priceInfoArr"
              :key="infoItem.label"
              :style="infoItem?.itemStyle"
            >
              <div class="price_title">{{ infoItem.label }}</div>
              <div
                v-if="infoItem.key === 'serviceAttribution'"
                class="price_details service_attribution"
                @click="goServiceAttributionDetail"
              >
                <auth-img :src="right" alt="" class="right" />
              </div>
              <div v-else-if="infoItem.key === 'defaultCharge'" class="price_details is_free">
                {{ handleLabel(data, 'defaultCharge') }}
              </div>
              <div v-else-if="infoItem.key === 'thisPatientChargeString'" class="price_details">
                <consultationDetail
                  :currentPrice="data[infoItem.key]"
                  :ucUserId="data.ucUserId"
                  :isRenderOnParentNode="true"
                />
              </div>
              <div
                v-else-if="
                  [
                    'doctorDefaultConsultFeeConfigList',
                    'doctorPhoneDefaultConsultFeeConfigList',
                    'doctorVideoDefaultConsultFeeConfigList'
                  ].includes(infoItem.key)
                "
                class="price_list"
                :style="infoItem.valueStyle"
              >
                <a-tag v-for="(item, index) in data[infoItem.key]" :key="index" class="price_item">
                  {{ detailPrice(item, infoItem.type) }}
                </a-tag>
              </div>
              <div
                v-else-if="infoItem.key === 'firsCureFree'"
                class="price_details"
                :class="{ isOpen: data[infoItem.key] }"
              >
                {{ ['未开启', '已开启'][data[infoItem.key]] }}
              </div>
              <div
                v-else-if="infoItem.key === 'doctorAddCureFree'"
                class="price_details"
                :class="{ isOpen: data[infoItem.key] }"
              >
                {{ ['未开启', '已开启'][data[infoItem.key]] }}
              </div>

              <div v-else class="price_details">--</div>
            </div>
          </div>
          <!-- 医生排班 -->
          <div
            class="doc_schedule_container"
            :class="{ dividingLine: dividingFlag }"
            v-if="activeKey === 'doctor'"
          >
            <docSchedule @helpEditDoc="editDocTime"></docSchedule>
          </div>
          <div class="footer-button">
            <a-button
              class="button"
              v-if="
                activeKey === 'doctor' &&
                curOrder.doctorDaGroupId != activeGroupKey &&
                !isRecommendDoctor &&
                !ifFollowUp
              "
              @click="
                () => {
                  popoverVisible = false
                  emit('chatWithDoc')
                }
              "
              type="primary"
            >
              发起私聊
            </a-button>
            <template v-if="props.activeKey !== 'assistant' && !isRecommendDoctor">
              <a-button class="button" block @click="onSendSMS">发送短信</a-button>
              <SendSMS ref="sms"></SendSMS>
            </template>
            <a-button v-if="!isRecommendDoctor" class="button" block @click="call">
              拨打电话
            </a-button>
          </div>
        </div>
      </template>
      <slot name="content" v-if="activeKey !== 'patient'"></slot>
    </a-popover>
    <slot name="content" v-if="activeKey === 'patient'"></slot>
    <serviceRecord
      :serviceRecordVisible="serviceRecordVisible"
      @onClose="serviceRecordVisible = false"
    ></serviceRecord>
    <bindDoc :bindDocVisible="bindDocVisible" @onClose="bindDocVisible = false"></bindDoc>
    <AppointSetting ref="appointSetRef" />
    <SetRetreatment ref="treatmentRef" isSheet />
    <!-- 服务归属弹窗 -->
    <ServiceAttributionModal ref="serviceAttributionRef" :data="data" />
    <!-- 口碑赞誉 -->
    <SatisfactionPopover ref="satisfactionPopoverRef" />
  </div>
</template>
<script setup>
import head_p from '@/assets/img/chat/head_p.png'
import head_d from '@/assets/img/chat/head_d.png'
import head_a from '@/assets/img/chat/head_a.png' // BD的默认头像
import male from '@/assets/img/chat/male.png'
import female from '@/assets/img/chat/female.png'
import location from '@/assets/img/chat/location.png'
import healthIcon from '@/assets/img/chat/health.png'
import service from '@/assets/img/chat/service.png'
import right from '@/assets/img/chat/right.png'
import { reactive, defineProps, computed, defineEmits, ref, createVNode } from 'vue'
import { useStore } from 'vuex'
import docSchedule from '../components/docSchedule.vue'
import serviceRecord from './serviceRecord.vue'
import AppointSetting from '../components/AppointSetting'
import bindDoc from './bindDoc.vue'
import consultationDetail from './consultationDetail.vue'
import { Empty, Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons-vue'
import { callOut } from '@/utils/Tccc'
import SetRetreatment from '@/views/WorkPlace/Container/chat/components/retreatment/setRetreatment.vue'
import RemarkPopover from '@/components/RemarkPopover'
import SendSMS from '@/components/SendSMS/index'
import ServiceAttributionModal from '@/views/WorkPlace/Container/chat/components/ServiceAttributionModal'
import { priceInfoArr, docRecordStatus, docAuthStatus } from './config'
import moment from 'moment'
import { formatAmount, detailPrice } from '@/utils'
import SatisfactionPopover from '../components/satisfactionPop'
const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
import Config from '@/config/index'
const emit = defineEmits([
  'healthInfo',
  'talk',
  'updateRemark',
  'chatWithDoc',
  'showPopoverVisible'
])
const store = useStore()
const isGuideConsult = computed(() => store.state.workOrder.isGuideConsult)
const curOrder = computed(() => store.state.workOrder.workOrderGroupInfo)
const serviceRecordVisible = ref(false)
const bindDocVisible = ref(false)
const popoverVisible = ref(false)

// 认证备案信息
const certificationInfo = computed(() => {
  const list = []
  const { certificationStatus, recordStatus, registerSourceDesc } = props.data || {}
  if (registerSourceDesc) {
    list.push({
      label: registerSourceDesc
    })
  }
  if (docAuthStatus[certificationStatus]) {
    list.push(docAuthStatus[certificationStatus])
  }
  if (docRecordStatus[recordStatus]) {
    list.push(docRecordStatus[recordStatus])
  }

  return list.length ? list : null
})

const props = defineProps({
  activeKey: {
    type: String,
    required: true,
    default: 'patient'
  },
  placement: {
    type: String,
    required: false,
    default: 'leftTop'
  },
  trigger: {
    type: String,
    required: false,
    default: 'click'
  },
  data: {
    type: Object,
    required: true,
    default: () => {} // 展示的数据
  },
  isPatChat: {
    type: Boolean
  },
  bindDocList: {
    type: Array,
    required: false,
    default: () => [] // 患者绑定的医生
  },
  showMoreBindDoc: {
    type: Boolean,
    default: false
  },
  //关联工单列表
  dealWorkOrderList: {
    type: Array,
    required: false,
    default: () => [] // 患者绑定的医生
  },
  activeGroupKey: {
    // 当前获取的群组id
    type: String,
    default: ''
  },
  mouseEnterDelay: {
    // 鼠标移入后延时多久显示
    type: Number,
    default: 0.1
  },
  isRecommendDoctor: {
    type: Boolean,
    default: false
  },
  ifFollowUp: {
    type: Boolean,
    default: false
  }
})

const handleImg = gender => {
  if (gender === 0) {
    return female
  } else if (gender === 1) {
    return male
  } else {
    return ''
  }
}
const sms = ref()
function onSendSMS() {
  // console.log(props.data)
  const roleMAP = {
    patient: 1,
    doctor: 2,
    assistant: 3
  }
  const role = roleMAP[props.activeKey]
  const pInfo = {
    id: curOrder.value.patientInfo.ucUserId,
    name: curOrder.value.patientInfo.username
  }
  const dInfo = {
    id: props.activeKey === 'doctor' ? props.data.ucUserId : curOrder.value.doctorInfo.ucUserId,
    name: props.activeKey === 'doctor' ? props.data.username : curOrder.value.doctorInfo.username
  }
  const workId = curOrder.value.targetWorkOrder.workOrderId
  sms.value.open(role, pInfo, dInfo, workId)
  popoverVisible.value = false
}
const call = () => {
  popoverVisible.value = false
  Modal.confirm({
    centered: true,
    title: '确定拨打电话',
    icon: createVNode(ExclamationCircleOutlined),
    content: `确定给${item.value.p_title.type}-${props.data.username}拨打电话吗？`,
    okText: '拨打',
    cancelText: '取消',
    onOk: () => {
      const params = {
        calleeType: item.value.p_title.calleeType,
        calleeUcUserId: props.data.ucUserId,
        doctorId:
          props.activeKey === 'doctor'
            ? props.data.businessId
            : curOrder.value.doctorInfo.businessId,
        workOrderIds: [curOrder.value.targetWorkOrder.workOrderId]
      }
      callOut(params, {
        userType: item.value.p_title.type,
        name: props.data.username
      })
    }
  })
}
const item = computed(() => solesList[props.activeKey])
const dividingFlag = computed(() => {
  const { consultationTimeLastUpdateBy, consultationTimeLastUpdateAt } = props.data
  return consultationTimeLastUpdateBy || consultationTimeLastUpdateAt ? true : false
})
const solesList = reactive({
  patient: {
    cb: head_p, // 默认头像
    p_title: {
      label: '患者ID：',
      key: 'ucUserId',
      type: '患者',
      calleeType: 1
    }
    // p_content: [
    //   {
    //     label: 'BD备注',
    //     key: 'patientRemark'
    //   }
    // ]
  },
  doctor: {
    cb: head_d, // 默认头像
    p_title: {
      label: '医生ID：',
      key: 'businessId',
      type: '医生',
      calleeType: 2
    },
    p_content: [
      {
        label: '所属机构',
        key: 'hospitalName'
      },
      {
        label: '岗位职级',
        key: 'doctorTitleId'
      },
      {
        label: '个人简介',
        key: 'introduction'
      },
      {
        label: '个人公告',
        key: 'notice'
      },
      {
        label: '',
        key: 'changeAt'
      }
    ]
  },
  assistant: {
    cb: head_a, // 默认头像
    p_title: {
      label: 'ERP：',
      key: 'erpId',
      type: 'BD',
      calleeType: 3
    },
    p_content: [
      {
        label: '所属部门',
        key: 'bdDepartmentName'
      }
    ]
  }
})
// 岗位职级处理 `doctorTitleId`职级。0医师，1副主任医师，2主任医师，3主治医师，4住院医师'，5心理咨询师，6二级心理咨询师，7三级心理咨询师',
const doctorTitleText = [
  '医师',
  '副主任医师',
  '主任医师',
  '主治医师',
  '住院医师',
  '心理咨询师',
  '二级心理咨询师',
  '三级心理咨询师'
]
const handleLabel = (data, key) => {
  if (key === 'doctorTitleId') {
    return doctorTitleText[`${data[key]}`] || '--'
  } else if (key === 'changeAt') {
    return data[`${key}`] ? moment(data[`${key}`]).format('YYYY-MM-DD HH:mm') + '  更新' : ''
  } else if (key === 'defaultCharge') {
    return data[`${key}`] === 0 ? '免费' : formatAmount(data[`${key}`]) + '元/次'
  } else {
    return data[`${key}`] || '--'
  }
}
const getPopupContainer = trigger => {
  return trigger.parentNode
}
const showPopExcus = item => {
  const { courseServicesFlag, courseServicesCause } = item
  const excusList = [
    '患者待加入全病程服务',
    '患者已加入全病程服务',
    `患者未加入全病程服务:${courseServicesCause}`
  ]
  return excusList[courseServicesFlag]
}
const healthInfo = () => {
  emit('healthInfo')
}
// 查看服务记录
function goServiceReocrd() {
  serviceRecordVisible.value = true
  popoverVisible.value = false
}
// 查看更多绑定医生
function goBindDocList() {
  bindDocVisible.value = true
  popoverVisible.value = false
}
// 查看复诊日期表
const treatmentRef = ref(null)
function goTreatSheet() {
  popoverVisible.value = false
  treatmentRef.value.treatmentInit()
}

const appointSetRef = ref()
const editDocTime = () => {
  popoverVisible.value = false
  Modal.confirm({
    centered: true,
    title: '提示',
    icon: createVNode(ExclamationCircleOutlined),
    content: `确定为医生修改线下出诊？请与医生沟通确认。`,
    okText: '已确认',
    cancelText: '取消',
    onOk: () => {
      appointSetRef.value.settingInit()
    }
  })
}
const serviceAttributionRef = ref()
// 打开医生服务归属弹窗
const goServiceAttributionDetail = () => {
  popoverVisible.value = false
  serviceAttributionRef.value.showModal()
}
// 查看口碑赞誉
const satisfactionPopoverRef = ref(null)
const satisfactionClick = () => {
  popoverVisible.value = false
  satisfactionPopoverRef.value.initModal({
    ucDoctorId: curOrder.value.doctorInfo.ucUserId
  })
}
</script>
<style lang="scss">
.course_tips {
  min-width: 190px;
  text-align: center;
}
</style>
<style scoped lang="scss">
.container {
  // ::v-deep(.ant-popover-title) {
  //   padding: 24px 0;
  //   margin: 0 24px;
  //   width: 304px;
  // }
  // ::v-deep(.ant-popover-inner-content) {
  //   padding: 0 0 24px 0;
  //   margin: 0 24px;
  //   width: 304px;
  // }
  ::v-deep(.ant-popover.solePopover-container) {
    &::-webkit-scrollbar {
      display: none;
    }
    max-height: 78vh;
    overflow-y: auto;
    box-shadow: -2px 2px 6px 0 #b5c6e526;
  }
  .popover-header {
    justify-content: flex-start;
    &-img {
      width: 60px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      .auth {
        position: absolute;
        top: 0;
        left: 0;
        width: 46px;
        height: 18px;
        background: #e6e6e6;
        border-radius: 4px 0 8px 0;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        text-align: center;
        &.real {
          color: #ffffff;
          background: #ffa940;
        }
      }
      img {
        width: 100%;
      }
    }
    &-info {
      flex-direction: column;
      justify-content: space-around;
      margin-left: 12px;
      .name {
        font-weight: 500;
        font-size: 16px;
        color: #666666;
        align-items: center;
        line-height: 20px;
        justify-content: flex-start;
        img {
          width: 16px;
          height: 16px;
        }
        div {
          padding-right: 2px;
        }
      }
      .base_info {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
      }
      .number {
        margin-top: 5px;
        .age {
          display: inline-block;
          margin-left: 24px;
          padding-left: 24px;
          border-left: 1px solid #999999;
        }
      }

      .permission {
        color: red;
      }

      .location {
        color: #999999;
        margin-top: 4px;
        display: flex;
        align-items: center;
        img {
          width: 12px;
          height: 12px;
          margin-right: 5px;
        }
      }
    }
    &-ext {
      margin-left: auto;
      flex-shrink: 0;
      .satisfaction {
        cursor: pointer;
        padding: 4px 12px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #82544e;
        border-radius: 6px;
        background-image: linear-gradient(90deg, #fef0e8 0%, #fcdac5 100%);
      }
    }
  }
  .certificationInfoStyle {
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    margin-left: 73px;
  }
  .ServiceTags {
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    .ServiceTag {
      font-weight: 500;
      color: #b97642;
      font-size: 10px;
      border: 1px solid #d0a279;
      border-radius: 4px;
      padding: 2px 6px;
      height: 20.1px;
      line-height: 14px;
      margin: 0 8px 2px 0;
      background-color: #fff;
    }
  }
  .popover-content {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    .health_service {
      flex-wrap: wrap;
      justify-content: space-between;
      border-bottom: 1px solid #f0f0f0;

      .btn {
        margin: 6px 0;
        padding: 9px 0;
        border-radius: 4px;
        font-size: 14px;
        color: #333333;
        line-height: 14px;
        width: 50%;
        justify-content: center;
        align-items: center;
        &:hover {
          background-color: #f3f4f4;
          cursor: pointer;
        }
        img {
          width: 16px;
          height: 16px;
        }
        span {
          padding: 0 16px 0 8px;
        }
        .right {
          width: 12px;
          height: 12px;
        }
      }
    }
    .box_container {
      overflow-y: scroll;
      max-height: 200px;
    }
    .box {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      &.first_box {
        margin-top: 12px;
      }
      &.last_box {
        margin-bottom: 12px;
      }
      .title {
        color: #999999;
        margin-right: 16px;
        width: 60px;
      }
      .details {
        width: calc(100% - 72px);
        .departName {
          border-right: 1px solid #999999;
          padding-right: 10px;
          margin-right: 6px;
        }
      }
    }
    .announcement_update {
      color: #999999;
    }
    .doctor_price_info {
      padding-top: 12px;
      border-top: 1px solid #f0f0f0;
      border-bottom: 1px solid #f0f0f0;
      .info_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        gap: 10px;
        .price_title {
          color: #333333;
          flex-shrink: 0;
        }
        .price_details {
          color: #999999;
          display: flex;
          align-items: center;
        }
        .price_list {
          color: #999999;
          .price_item {
            border-radius: 4px;
            border: 1px solid #dbdbdb;
            padding: 3px 5px;
            background: #ffffff;
            font-size: 12px;
            color: #666666;
            margin-right: 6px;
            line-height: 1;
          }
        }

        .isOpen {
          color: #24bca2;
        }
        .is_free {
          color: #1890ff;
        }
        .service_attribution {
          min-width: 150px;
          cursor: pointer;
          display: flex;
          justify-content: flex-end;
          .right {
            width: 12px;
            height: 12px;
          }
        }
      }
    }
    .footer-button {
      margin-top: 12px;
      width: 100%;
      justify-content: space-between;
      .button {
        width: 100%;
        border-radius: 4px;
        margin-top: 8px;
        &:first-child {
          margin-top: 0;
        }
      }
      .callbtn {
        background: #f0f0f0;
        border: none;
      }
    }
    .consultationFee {
      position: relative;
      // display: flex;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      padding: 5px 14px;
      background: #f8f8f8;
      border-radius: 6px;
      overflow: hidden;
      width: 100%;
      // justify-content: space-between;
      margin-top: 10px;
      .price {
        font-weight: 400;
        font-size: 14px;
        color: #ff992b;
      }
    }
    .bind_doc {
      padding-top: 16px;
      .title {
        color: #999999;
        font-weight: 400;
        font-size: 14px;
        .more_data {
          color: #333333;
          cursor: pointer;
          img {
            width: 12px;
            height: 12px;
            margin-left: 8px;
          }
        }
      }
      .doctap {
        background: #f8f8f8;
        border-radius: 8px;
        padding: 12px;
        margin-top: 8px;
        position: relative;
        .course_sign {
          position: absolute;
          top: 0;
          right: 0;
          .flag_str {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            width: 60px;
            height: 20px;
            border-radius: 0 8px 0 8px;
          }
          .flag_join {
            background: #1890ff1a;
            color: #1890ff;
          }
          .flag_ex {
            background: #f0f0f0;
            color: #666666;
          }
        }
        ::v-deep(.ant-empty-normal) {
          margin: 15px 0;
        }
        .info {
          margin-bottom: 9px;
          .name {
            font-size: 14px;
            color: #1a1a1a;
            padding-right: 12px;
          }
          .txt {
            font-size: 12px;
            color: #999999;
          }
          .depart {
            padding-right: 6px;
            margin-right: 6px;
            border-right: 1px solid #999999;
          }
        }
        .hosp {
          margin-bottom: 19px;
          font-weight: 400;
          font-size: 12px;
          color: #3b3b3b;
        }
        .explain {
          .source {
            font-weight: 400;
            font-size: 12px;
            color: #3b3b3b;
          }
          .date {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
        }
      }
    }
    .doc_schedule_container {
      margin-top: 12px;
    }
    .dividingLine {
      padding-bottom: 12px;
      border-bottom: 1px solid #f0f0f0;
    }
  }
}
</style>
